// extracted by mini-css-extract-plugin
export default {"imageContainer":"eventDetailed_imageContainer__VFX3E","imageSubContainer":"eventDetailed_imageSubContainer__-TYQ-","image":"eventDetailed_image__eVEoH"};